class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.loadRecommendations();
  }

  loadRecommendations() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;

          this.initializeWishlistFeatures();
          this.initializeCompareButtons();
          this.initializeCountdown();

          // swiper init
          setTimeout(() => {
            if (typeof window.initializeSlider === 'function') {
              window.initializeSlider();
            }
          }, 300);
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  initializeWishlistFeatures() {
    const buttons = this.querySelectorAll(selectorss.button);
    if (buttons.length) {
      setupButtons(buttons);
    }
    updateWishlistCount();
  }

  initializeCompareButtons() {
    const buttons = this.querySelectorAll(compareSelectors.button);
    if (buttons.length) {
      setupCompareButtons(buttons);
    }
  }

  initializeCountdown() {
    const clockdivs = this.querySelectorAll('.clockdiv');

    clockdivs.forEach((clockdiv) => {
      const attrDate = new Date(clockdiv.getAttribute('data-date'));
      const now = new Date();

      if (now > attrDate) {
        clockdiv.style.display = 'none';
        return;
      }

      const updateCountdown = () => {
        const distance = attrDate - new Date().getTime();
        if (distance < 0) {
          clockdiv.style.display = 'none';
          return;
        }

        clockdiv.querySelector('.days').innerText = Math.floor(distance / (1000 * 60 * 60 * 24));
        clockdiv.querySelector('.hours').innerText = Math.floor((distance / (1000 * 60 * 60)) % 24);
        clockdiv.querySelector('.minutes').innerText = Math.floor((distance / (1000 * 60)) % 60);
        clockdiv.querySelector('.seconds').innerText = Math.floor((distance / 1000) % 60);
      };

      updateCountdown();
      setInterval(updateCountdown, 1000);
    });
  }
}

customElements.define('product-recommendations', ProductRecommendations);
